// ugly way of accessing the data - server returns either an object with array inside or just an empty array
export const formatCodeBook = (object) =>
  (object.data && object.data.dictionaryValueList
    ? object.data.dictionaryValueList
    : []
  ).map((item) => ({
    value: item.value,
    label: item.description,
  }));
